import { RootState } from "@/redux/store";
import { routes } from "@/routes/utils";
import { useMemo } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const useCustomTemplates = () => {
  const navigate = useNavigate();
    const communityDetail = useSelector(
      (state: RootState) => state.currentData.communityData
    );

    const breadcrumbData = useMemo(
      () => [
        {
          link: `/${routes.admin}/${routes.masterData}/${routes.templates}`,
          name: `Templates - ${communityDetail?.name || ""}`,
        },
        {
          link: "",
          name: <span className="text-primary">Custom Template</span>,
        },
      ],
      []
    );
    
    const onBackClick = () => {
      navigate(`/${routes.admin}/${routes.masterData}/${routes.templates}`);
    };

    const onCardClick = () =>{
      navigate(`${routes.stateLevelTnc}`);
    };

    return {
      communityDetail,
      breadcrumbData,
      onBackClick,
      onCardClick
    };
};

export default useCustomTemplates;